module.exports = __webpack_public_path__ + "static/img/Brad-Crouch.7249a52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brad-Crouch.jpg
// module id = gr96
// module chunks = 0